import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Mobile } from "../../../assets/icon";
const AddModalWriters = ({ setShowModal, title, buttonName, setRecheck, reCheck, data, cats }) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [approvalRequired, setApprovalRequired] = useState("yes"); // حالت پیش‌فرض: "دارد"
    const [error, setError] = useState();
    const [catError, setCatError] = useState(false)

    const options = [
        { value: "category1", label: "دسته ۱" },
        { value: "category2", label: "دسته ۲" },
        { value: "category3", label: "دسته ۳" },
        { value: "category4", label: "دسته ۴" },
    ];

    const [allValues, setAllValues] = useState({
        NationalCode: data ? data.nationalCode : '',
        AuthorName: data ? data.authorName : '',
        AuthorFamily: data ? data.authorFamily : '',
        Mobile: data ? data.mobile : '',
        UserName: data ? data.userName : '',
        StatusAuthor: data ? data.statusAuthor.toString() : "false",
        Password: data ? data.password : ''

    });
    const [allValuesError, setAllValuesError] = useState({
        NationalCode: false,
        AuthorName: false,
        AuthorFamily: false,
        PhoneNumber: false,
        UserName: false,
        Password: false,
        StatusAuthor: false
    });

    useEffect(() => {
        var catss = []
        console.log(999)
        data?.authorCategoryTbls?.map((item) => {
            catss.push({ value: item.category?.categoryId, label: item.category?.categoryName })
        })
        setSelectedOptions(catss);
    }, []);
    const blurHandler = e => {
        if (e.target) {
            if (e.target.value == "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }


        }

    }

    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })

            }
            // setAllValuesError({ ...allValuesError, [""]: false })


            setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
    }
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            addAdmin();
        }
    };
    const handleSelectChange = (selected) => {
        setCatError(false)
        setSelectedOptions(selected || []);
    };
    const handleRadioChange = (e) => {
        setAllValues({ ...allValues, [e.target.name]: e.target.value })

    };

    const addAdmin = async () => {
        let check = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

        setSnipper(true)
        console.log(selectedOptions)


        if (!allValues.Password.match(check)) {
            setAllValuesError({ ...allValuesError, Password: true })
        }
        if (selectedOptions.length == 0) {
            setCatError(true)
        }
        var res = allFull(allValues)
        console.log(res)

        if (res && selectedOptions.length > 0) {
            var catSel = "";
            selectedOptions?.map((item) => {
                catSel += item?.value + ","
            })
            const dataUser = await axiosReq("Admins/CreateAuthor", "post", {
                NationalCode: allValues?.NationalCode,
                AuthorName: allValues?.AuthorName,
                AuthorFamily: allValues?.AuthorFamily,
                Mobile: allValues?.Mobile,
                UserName: allValues?.UserName,
                Password: allValues?.Password,
                Categories: catSel,
                StatusAuthor: allValues?.StatusAuthor
            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)

                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");
                setShowModal(false);
            }
            else {
                console.log(allValuesError)
                console.log(dataUser)
                setError(dataUser?.data)

                setShowErrorModalStep1(true);
            }
        }
        else {
            setError("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);


        }
    }

    const editAdmin = async () => {
        let check = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

        setSnipper(true)
        if (!allValues.Password.match(check)) {
            setAllValuesError({ ...allValuesError, Password: true })
        }
        var res = allFull(allValues)
        console.log(res)
        if (selectedOptions.length == 0) {
            setCatError(true)
        }
        if (res) {
            var catSel = "";
            selectedOptions?.map((item) => {
                catSel += item?.value + ","
            })
            const dataUser = await axiosReq("Admins/UpdateAuthor", "put", {
                AuthorId: data?.authorId,
                NationalCode: allValues?.NationalCode,
                AuthorName: allValues?.AuthorName,
                AuthorFamily: allValues?.AuthorFamily,
                Mobile: allValues?.Mobile,
                UserName: allValues?.UserName,
                Password: allValues?.Password,
                Categories: catSel,
                StatusAuthor: allValues?.StatusAuthor

            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)

                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");
                setShowModal(false)
            }
            else {
                console.log(allValuesError)
                setError(dataUser?.data)

                setShowErrorModalStep1(true);
            }
        }
        else {
            console.log(allValuesError)
            setError("لطفا موارد خواسته شده را وارد نمایید")

            setShowErrorModalStep1(true);

        }
    }
    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "") {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
            // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
            //     updatedState[o] = true;


            //     setAllValuesError({ ...allValuesError, ...updatedState })
            //     result = false;
            // }

        }
        console.log(allValuesError)
        return result
    }
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: state.isFocused ? "#f1f5ff" : "#f1f5ff",
            borderRadius: 5, // رنگ بوردر در حالت فوکوس و غیرفوکوس
            "&:hover": {
                borderColor: "#f1f5ff", // رنگ بوردر هنگام هاور
            },
            boxShadow: state.isFocused ? "none" : "none", // سایه در حالت فوکوس
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#e8eeff", // رنگ پس‌زمینه تگ‌های انتخاب شده
            color: "#fff",
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: "#000", // رنگ متن تگ‌های انتخاب شده
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: "#000",
            "&:hover": {
                backgroundColor: "#E64A19", // رنگ پس‌زمینه دکمه حذف هنگام هاور
                color: "white",
            },
        }),
    };
    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[30%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام</span>
                                <input
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    name="AuthorName"
                                    placeholder="نام را اینجا بنویسید"
                                    value={allValues?.AuthorName}
                                    onKeyPress={(event) => {
                                        if (/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                        if (/[۱-۹]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" />
                                {
                                    allValuesError.AuthorName ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام خانوادگی</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="نام خانوادگی را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="AuthorFamily"
                                    onChange={changeHandler}
                                    value={allValues?.AuthorFamily}
                                    onInput={maxLengthCheck}
                                    onKeyPress={(event) => {
                                        if (/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                        if (/[۱-۹]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                    maxLength={100} />
                                {
                                    allValuesError.AuthorFamily ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام خانوادگی را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px]  flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">کد ملی</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="کد ملی را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="NationalCode"
                                    onChange={changeHandler}
                                    value={allValues?.NationalCode}
                                    onInput={maxLengthCheck}
                                    maxLength={10}
                                    onKeyPress={(event) => {
              
                                        if (/[ا-ی]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                       
                                     
                                        if (/[a-z]/.test(event.key)) {
                                            event.preventDefault();
                                          }
                                          if (/[A-Z]/.test(event.key)) {
                                            event.preventDefault();
                                          }
                                    }}
                                />
                                {
                                    allValuesError.NationalCode ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا کدملی را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">شماره همراه</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" 
                                    placeholder="شماره همراه را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    onChange={changeHandler}
                                    name="Mobile"
                                    onKeyPress={(event) => {
              
                                        if (/[ا-ی]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    
                                        if (/[a-z]/.test(event.key)) {
                                            event.preventDefault();
                                          }
                                          if (/[A-Z]/.test(event.key)) {
                                            event.preventDefault();
                                          }
                                    }}
                                    value={allValues?.Mobile}
                                    onInput={maxLengthCheck}
                                    maxLength={11}
                                />
                                   {
                                    allValuesError.Mobile ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا شماره همراه را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام کاربری</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="نام کاربری را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="UserName"
                                    onChange={changeHandler}
                                    value={allValues?.UserName}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                />
                                {
                                    allValuesError.UserName ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام کاربری را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">رمز عبور</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="رمز عبور را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="Password"
                                    onChange={changeHandler}
                                    // value={allValues?.Password}
                                    onInput={maxLengthCheck}
                                    maxLength={10}
                                />
                                {
                                    allValuesError.Password ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            رمز عبور هشت رقم و دارای حرف بزرگ و کوچک ، عدد و یکی از(.@?!*) می باشد!</span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-2 mb-[10px] flex flex-col">
                                <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-1">انتخاب دسته بندی برای این نویسنده</p>
                                <div className="w-full">
                                    <Select
                                        options={cats}
                                        isMulti
                                        value={selectedOptions}
                                        onChange={handleSelectChange}
                                        placeholder="دسته‌ها را انتخاب کنید"
                                        styles={customStyles}
                                        className="text-[12px] font-IRANYekanNormal focus:outline-lightGray border-[1px] border-borderGray rounded-[5px]"
                                    />
                                    {
                                        catError ?
                                            <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                                لطفا دسته را وارد نمایید !
                                            </span>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                            <div className="col-span-2 mb-[10px] flex flex-col  mt-4">
                                <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-2">
                                    خبر بارگزاری شده توسط این نویسنده نیاز به تایید :
                                </p>
                                <div className="flex items-center space-x-4 space-x-reverse">
                                    <label className="flex items-center">
                                        <input
                                            type="radio"
                                            name="StatusAuthor"
                                            value="false"
                                            checked={allValues.StatusAuthor == "false"}
                                            onChange={handleRadioChange}
                                            className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                                        />
                                        <span className="ml-2 text-[14px] font-IRANYekanNormal">دارد</span>
                                    </label>
                                    <label className="flex items-center">
                                        <input
                                            type="radio"
                                            name="StatusAuthor"
                                            value="True"
                                            checked={allValues.StatusAuthor == "True"}
                                            onChange={handleRadioChange}
                                            className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                                        />
                                        <span className="ml-2 text-[14px] font-IRANYekanNormal">ندارد</span>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                            <button onClick={() => title == "ویرایش" ? editAdmin() : addAdmin()} className="h-[40px] w-[107px] bg-Orange2 rounded-[10px]"><p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p></button>
                        </div>
                    </div>
                </div>
                {showErrorModalStep1 ?
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-[30%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold   text-red">
                                            درخواست اشتباه !
                                        </span>

                                    </div>

                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm   leading-relaxed">
                                            {error}                                        </p>
                                    </div>

                                    <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                        <Link

                                            className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow   bg-Orange2 font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            فهمیدم
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                    </>
                    : null
                }
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default AddModalWriters;